module.exports = __webpack_public_path__ + "static/img/xd_8_e.8c66760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xd_8_e.png
// module id = 57He
// module chunks = 1